import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import type { FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { Markdown } from 'src/components/data-display/markdown';
import { Checkbox } from 'src/components/form/checkbox';
import { ExternalLink } from 'src/components/navigation/link';
import { Modal } from 'src/components/overlay/modal';
import { useModal } from 'src/hooks/use-modal';

export const AcceptGtc: FC<{
  name: string;
  operatorName: string;
  link: string;
  /** @deprecated Remove this when the TAG-7505 evaluation phase is over. */
  withUnderlinedLinks?: boolean;
}> = ({ name, operatorName, link, withUnderlinedLinks }) => (
  <Checkbox
    name={name}
    label={`${operatorName} General Terms and Conditions`}
    hideLabel
    optionLabel={
      <>
        I have read and accept the {operatorName}{' '}
        {withUnderlinedLinks ? (
          <ExternalLink mode="default-underlined" href={link} target="_blank">
            General Terms and Conditions
          </ExternalLink>
        ) : (
          <strong>
            <ExternalLink href={link} target="_blank">
              General Terms and Conditions
            </ExternalLink>
          </strong>
        )}
        .*
      </>
    }
  />
);

export const AcceptSpecificCondition: FC<{
  name: string;
  operatorName: string;
  label: string;
  note: string;
  /** @deprecated Remove this when the TAG-7505 evaluation phase is over. */
  withUnderlinedLinks?: boolean;
}> = ({ name, operatorName, label, note, withUnderlinedLinks }) => {
  const modal = useModal((props) => (
    <Modal
      title={label}
      icon={faInfoCircle}
      onDismiss={props.close}
      confirmButton={null}
      closeButton={props.closeButton}
    >
      <Markdown content={note} />
    </Modal>
  ));

  return (
    <Checkbox
      name={name}
      label={`${operatorName} Specific Conditions`}
      hideLabel
      optionLabel={
        <>
          I have read and accept the {operatorName}{' '}
          {withUnderlinedLinks ? (
            <Button mode="link-underlined" onClick={modal.open}>
              {label}
            </Button>
          ) : (
            <strong>
              <Button mode="link" onClick={modal.open}>
                {label}
              </Button>
            </strong>
          )}
          .*
        </>
      }
    />
  );
};
